<template>
  <Popover ref="customFieldsPopover" :showHeader="true" headerTitle="Custom Fields">
    <div class="order-item-popover-content">
      <div v-if="!isCustomFieldLookupEmpty">
        <StaticDataTable class="static-table-list" :striped="false" :smallRows="true">
          <template v-slot:header>
            <tr>
              <th width="38%">Field</th>
              <th width="58%">Value</th>
              <th> </th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="(fieldInfo, index) of customFieldEditList" :key="index">
              <td><FormSelect class="form-input-sm" placeholder="Field" :options="customFieldLookup" :value="fieldInfo.key" @input="updateCustomFieldKey(index, $event)" /></td>
              <td><FormInputText class="form-input-sm" placeholder="Value" :value="fieldInfo.value" @input="updateCustomFieldValue(index, $event)" /></td>
              <td><FormButton class="btn-default btn-xs" @click.stop="removeCustomFieldRow(index)"><i class="far fa-trash-alt"></i></FormButton></td>
            </tr>
          </template>
        </StaticDataTable>
        <FormButton class="btn-default btn-xs" @click="addCustomFieldRow"><i class="far fa-plus-circle"></i> Add</FormButton>
      </div>
      <div v-if="isCustomFieldLookupEmpty">No custom fields available. Please add fields in order settings</div>
    </div>
  </Popover>
</template>


<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'

export default {
  name: 'OrderItemCustomFieldPopover',
  model: {
    event: 'update'
  },
  components: {
    Popover
  },
  props: {
    customFieldLookupList: Array,
    value: [Object, Array]
  },
  data() {
    return {
      fieldEditList: _.cloneDeep(this.value || [])
    }
  },
  watch: {
    value(newValue) {
      this.fieldEditList = _.cloneDeep(newValue || [])
    }
  },
  computed: {
    hasCustomFields() {
      return _.isObject(this.fieldEditList) && !_.isEmpty(this.fieldEditList)
    },
    customFieldDisplayData() {
      if(_.isArray(this.fieldEditList)) {
        return 'Fields: ' + this.fieldEditList.map(field => {
          return `${field.key}: ${field.value}`
        }).join(', ')
      }
      return ''
    },
    customFieldEditList() {
      if(_.isArray(this.fieldEditList))
        return this.fieldEditList
      return []
    },
    customFieldLookup() {
      if(_.isArray(this.customFieldLookupList)) {
        return this.customFieldLookupList.map(field => {
          return {
            value: field,
            name: field
          }
        })
      }
      return []
    },
    isCustomFieldLookupEmpty() {
      return this.customFieldLookup.length == 0
    },
  },
  methods: {
    displayFromElement(element) {
      this.$refs.customFieldsPopover.displayFromElement(element)
    },

    updateCustomFieldKey(index, value) {
      this.fieldEditList[index].key = value

      this.$emit('update', this.fieldEditList)
    },
    updateCustomFieldValue(index, value) {
      this.fieldEditList[index].value = value

      this.$emit('update', this.fieldEditList)
    },
    removeCustomFieldRow(index) {
      this.fieldEditList.splice(index, 1)

      this.$emit('update', this.fieldEditList)
    },
    addCustomFieldRow() {
      if(!_.isArray(this.fieldEditList))
        this.fieldEditList = []

      this.fieldEditList.push({
        key: '',
        value: ''
      })

      this.$emit('update', this.fieldEditList)
    }
  }
}
</script>